module.exports = {
      id: "gzhome-usage",
      viewBox: "0 0 29.037 17.12",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#gzhome",
      toString: function () {
        return this.url;
      }
    }